<template>
  <table class="table layout-fixed">
    <thead>
      <tr>
        <slot name="header" />
      </tr>
    </thead>
    <tbody>
      <slot name="body" />
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'Table',
}
</script>
